import $ from 'jquery'
import VueLazyload from 'vue-lazyload'
import { ReadableStream } from 'web-streams-polyfill/es5'
import { bus } from './common/setup-app/event-bus'
import { setupApp } from './common/setup-app/setup-app'
import createStore from './vuex'
import 'bootstrap'
import './configuration'
import '../css/app.css'

window.$ = window.jQuery = $

if (!window.ReadableStream) {
  window.ReadableStream = ReadableStream
}

const app = setupApp()
if (app) {
  app.use(createStore())
  app.use(VueLazyload)
}

$(document).ready(() => {
  const $body = $('body')
  $('#kt_header_mobile_topbar_toggle').click(() => {
    $body.toggleClass('topbar-mobile-on')
  })
  // Quick panels
  $body.on('click', '.offcanvas-overlay, .kt_quick_panel_close', () => {
    $('#quick-panel .offcanvas-on').each((index, el) => {
      const id = $(el).attr('id')

      if (id) {
        bus.$emit('hide-quick-panel', `#${id}`)
      }
    })
    $('.offcanvas-overlay').addClass('d-none')
  })

  bus.$on('show-quick-panel', (selector) => {
    $body.find(selector).addClass('offcanvas-on')
    $('.offcanvas-overlay').removeClass('d-none')
  })
  bus.$on('hide-quick-panel', (selector) => {
    $body.find(selector).removeClass('offcanvas-on')
    $('.offcanvas-overlay').addClass('d-none')
  })
})
